import { autoinject } from 'aurelia-framework';
import { DialogController } from "aurelia-dialog";
import { Globals } from '../../models/globals';


@autoinject
export class CreateCarrierDialog {
    entityTypes: { id: string; description: string; }[];
    selectedEntityType: string;
    constructor(
        protected controller: DialogController
    ) {

        this.entityTypes = new Globals().getEntityTypes();

    }


    activate(params) {
    }

    ok() {
        this.controller.ok(this.selectedEntityType);
    }



}